import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	triggerPrefixLabel: {
		id: 'color-picker.trigger.prefix.label',
		defaultMessage: 'color',
		description: 'Prefix label text for color picker trigger',
	},
	triggerPostfixLabel: {
		id: 'color-picker.trigger.postfix.label',
		defaultMessage: 'trigger',
		description: 'Postfix label text for color picker trigger',
	},
});
